var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"lg":"12","sm":"12"}},[_c('b-table',{attrs:{"striped":"","responsive":"","items":_vm.summaryA1,"fields":_vm.summaryA1fields}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }